const lang =  {
    en : {
        search : "Search",
        searchPlaceholder : "what do you like to watch today?"
    },
    hindi : {
        search : "खोज",
        searchPlaceholder : "आप आज क्या देखना पसंद करते हैं?"
    },
    telugu : {
        search : "శోధన",
        searchPlaceholder : "మీరు ఈరోజు ఏమి చూడాలనుకుంటున్నారు?"
    }
}

export default lang;